export default __webpack_public_path__ + "media/images/ad_landing_page/Ernst-16441c8d064f57987fdcb59fdb1b229b.png";